import { SummaryItem } from '../../SummaryStore';

export function groupItemsByType(items: SummaryItem[]) {
  return items.reduce(
    (acc, item) => ({
      ...acc,
      [item.type]: acc[item.type] ? acc[item.type].concat(item) : [item]
    }),
    {} as Record<SummaryItem['type'], SummaryItem[]>
  );
}
